// extracted by mini-css-extract-plugin
export var mediaBlock = "index-module--mediaBlock--a6f64";
export var title = "index-module--title--5eb99";